/*
  STELT 09/2026 - Pop-up "Bottiglia aggiunta al carrello" (voce 42)

  - Ascolta "ajaxProduct:added" (emesso da block.product-buy-buttons.js e dal quick-add)
  - Legge il line item restituito da /cart/add.js e, se presente, l'HTML della sezione
    "cart-ajax" (subtotale e numero articoli gia' formattati da Liquid);
    in mancanza usa /cart.js e un formatMoney locale.
  - Mostra il pop-up (mobile: dal basso; desktop: in alto a destra, sotto l'header
    sticky cosi' non copre icona carrello e account), chiusura con X,
    "Continua", Esc e automatica dopo 4 s (in pausa con mouse/focus sul pannello).
  - Aggiorna il contatore carrello nell'header se esiste un elemento con
    [data-cart-count] / .cart-link__bubble-num / .ai-header-cart-count (solo textContent).
  - Nessuna dipendenza esterna. Tutto in try/catch: se qualcosa manca, non fa nulla.
*/
;(function () {
  'use strict'

  var SELECTOR = '[data-stelt-cart-popup]'
  var EVENT_ADDED = 'ajaxProduct:added'
  var COUNT_SELECTORS =
    '[data-cart-count], [data-header-cart-count], .cart-link__bubble-num, .ai-header-cart-count, .header__cart-count, .cart-count'

  function warn(error) {
    try {
      if (window.console && console.warn) console.warn('[stelt-cart-popup]', error)
    } catch (e) {
      /* silenzio */
    }
  }

  function root() {
    try {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
    } catch (e) {
      return '/'
    }
  }

  // STELT (16/09/2026): la valuta attiva della vetrina (mercati Shopify) puo' essere diversa
  // da quella base del negozio. formatMoney() qui sotto sa applicare solo il formato del
  // negozio: usato da solo mostrava l'importo giusto col simbolo sbagliato (es. "\u20ac130,00"
  // a chi sta comprando in dollari). money() intercetta quel caso e passa a Intl, che di
  // simboli e convenzioni per lingua ne sa piu' di noi.
  function activeCurrency() {
    try {
      var c = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      return c ? String(c).toUpperCase() : ''
    } catch (e) {
      return ''
    }
  }

  function money(cents, format, shopCurrency) {
    var active = activeCurrency()
    if (active && shopCurrency && active !== String(shopCurrency).toUpperCase()) {
      try {
        var n = cents
        if (typeof n === 'string') n = parseInt(n.replace(/[^0-9-]/g, ''), 10)
        if (typeof n !== 'number' || isNaN(n)) n = 0
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: active
        }).format(n / 100)
      } catch (e) {
        // Intl assente o codice valuta non valido: si ricade sul formato del negozio
      }
    }
    return formatMoney(cents, format)
  }

  function formatMoney(cents, format) {
    try {
      if (typeof cents === 'string') cents = parseInt(cents.replace(/[^0-9-]/g, ''), 10)
      if (typeof cents !== 'number' || isNaN(cents)) cents = 0

      var f = String(format || '{{amount_with_comma_separator}}').replace(/<[^>]*>/g, '')
      var m = f.match(/\{\{\s*(\w+)\s*\}\}/)
      var key = m ? m[1] : 'amount'

      function withDelims(n, precision, thousands, decimal) {
        var s = (n / 100).toFixed(precision)
        var parts = s.split('.')
        var int = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands)
        return parts[1] ? int + decimal + parts[1] : int
      }

      var v
      switch (key) {
        case 'amount':
          v = withDelims(cents, 2, ',', '.')
          break
        case 'amount_no_decimals':
          v = withDelims(cents, 0, ',', '.')
          break
        case 'amount_with_comma_separator':
          v = withDelims(cents, 2, '.', ',')
          break
        case 'amount_no_decimals_with_comma_separator':
          v = withDelims(cents, 0, '.', ',')
          break
        case 'amount_with_apostrophe_separator':
          v = withDelims(cents, 2, "'", '.')
          break
        case 'amount_no_decimals_with_space_separator':
          v = withDelims(cents, 0, ' ', '.')
          break
        case 'amount_with_space_separator':
          v = withDelims(cents, 2, ' ', ',')
          break
        case 'amount_with_period_and_space_separator':
          v = withDelims(cents, 2, ' ', '.')
          break
        default:
          v = withDelims(cents, 2, ',', '.')
      }
      return m ? f.replace(m[0], v).trim() : v
    } catch (e) {
      warn(e)
      return ''
    }
  }

  function parseSections(html, key) {
    var out = { total: '', count: null, linePrice: '' }
    try {
      if (!html || typeof html !== 'string') return out
      var doc = new DOMParser().parseFromString(html, 'text/html')

      var subtotal = doc.querySelector('.cart__subtotal')
      if (subtotal) out.total = subtotal.innerHTML.trim()

      var num = doc.querySelector('.cart-link__bubble-num')
      if (num) {
        var n = parseInt(num.textContent.replace(/[^0-9]/g, ''), 10)
        if (!isNaN(n)) out.count = n
      } else {
        var items = doc.querySelector('.cart__items[data-count]')
        if (items) {
          var c = parseInt(items.getAttribute('data-count'), 10)
          if (!isNaN(c)) out.count = c
        }
      }

      if (key) {
        var item = doc.querySelector('.cart__item[data-key="' + key + '"]')
        if (item) {
          var price = item.querySelector('.cart__price:not(.cart__price--strikethrough)')
          if (price) out.linePrice = price.innerHTML.trim()
        }
      }
    } catch (e) {
      warn(e)
    }
    return out
  }

  function fetchCart() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('cart.js ' + response.status)
      return response.json()
    })
  }

  function sanitizeHtml(html) {
    // Consentiamo solo <sup>/</sup> (decimali in apice del tema); il resto diventa testo
    try {
      var tmp = document.createElement('div')
      tmp.innerHTML = String(html || '')
      var text = ''
      tmp.childNodes.forEach(function (node) {
        if (node.nodeType === 3) {
          text += node.textContent
        } else if (node.nodeType === 1 && node.tagName === 'SUP') {
          text += '<sup>' + node.textContent.replace(/[<>]/g, '') + '</sup>'
        } else if (node.nodeType === 1) {
          text += node.textContent
        }
      })
      return text.replace(/\s+/g, ' ').trim()
    } catch (e) {
      return ''
    }
  }

  function imageUrl(url) {
    try {
      if (!url) return ''
      var u = String(url)
      if (u.indexOf('//') === 0) u = 'https:' + u
      if (/[?&]width=/.test(u)) return u
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=240'
    } catch (e) {
      return ''
    }
  }

  function localizedUrl(url) {
    try {
      if (!url) return ''
      var r = root()
      if (r === '/' || url.indexOf(r) === 0 || /^https?:/.test(url)) return url
      return r.replace(/\/$/, '') + url
    } catch (e) {
      return url || ''
    }
  }

  function updateHeaderCount(popup, count) {
    try {
      if (typeof count !== 'number' || isNaN(count)) return
      var nodes = document.querySelectorAll(COUNT_SELECTORS)
      nodes.forEach(function (el) {
        try {
          if (popup && popup.contains(el)) return
          el.textContent = String(count)
          el.setAttribute('data-count', String(count))
          if (el.hasAttribute('hidden') && count > 0) el.removeAttribute('hidden')
          var bubble = el.closest ? el.closest('.cart-link__bubble') : null
          if (bubble) bubble.classList.toggle('cart-link__bubble--visible', count > 0)
        } catch (e) {
          warn(e)
        }
      })
      document.dispatchEvent(new CustomEvent('stelt:cart-count', { detail: { count: count } }))
    } catch (e) {
      warn(e)
    }
  }

  function init() {
    var popups = document.querySelectorAll(SELECTOR)
    if (!popups.length) return

    var popup = popups[0]
    // Deduplica (scheda prodotto + prodotto in evidenza nella stessa pagina)
    for (var i = 1; i < popups.length; i++) {
      try {
        popups[i].remove()
      } catch (e) {
        warn(e)
      }
    }
    // Il pop-up e' position:fixed: lo portiamo in <body> per evitare antenati con transform
    try {
      var lives = document.querySelectorAll('[data-stelt-cart-popup-live]')
      var live = lives.length ? lives[0] : null
      for (var j = 1; j < lives.length; j++) lives[j].remove()
      if (popup.parentNode !== document.body) document.body.appendChild(popup)
      if (live && live.parentNode !== document.body) document.body.appendChild(live)
    } catch (e) {
      warn(e)
    }

    var q = function (sel) {
      return popup.querySelector(sel)
    }

    var panel = q('.stelt-cart-popup__panel')
    var primary = q('[data-stelt-cart-popup-primary]')
    var closers = popup.querySelectorAll('[data-stelt-cart-popup-close]')
    var imageWrap = q('.stelt-cart-popup__image')
    var itemWrap = q('.stelt-cart-popup__item')
    var image = q('[data-stelt-cart-popup-image]')
    var title = q('[data-stelt-cart-popup-title]')
    var variant = q('[data-stelt-cart-popup-variant]')
    var qty = q('[data-stelt-cart-popup-qty]')
    var price = q('[data-stelt-cart-popup-price]')
    var total = q('[data-stelt-cart-popup-total]')
    var count = q('[data-stelt-cart-popup-count]')
    var liveRegion = document.querySelector('[data-stelt-cart-popup-live]')

    var moneyFormat = popup.getAttribute('data-money-format') || ''
    var shopCurrency = popup.getAttribute('data-shop-currency') || ''
    var itemsOne = popup.getAttribute('data-items-one') || '1 articolo'
    var itemsOther = popup.getAttribute('data-items-other') || '%COUNT% articoli'
    var autoclose = parseInt(popup.getAttribute('data-autoclose'), 10)
    if (isNaN(autoclose)) autoclose = 4000

    var reduceMotion = false
    try {
      reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
    } catch (e) {
      reduceMotion = false
    }

    var state = { open: false, timer: null, trigger: null, paused: false, autoFocus: false }

    function clearTimer() {
      if (state.timer) {
        clearTimeout(state.timer)
        state.timer = null
      }
    }

    function startTimer() {
      clearTimer()
      if (!autoclose || autoclose <= 0 || state.paused) return
      state.timer = setTimeout(function () {
        close()
      }, autoclose)
    }

    function onKeydown(event) {
      try {
        if (event.key === 'Escape' || event.key === 'Esc') {
          event.preventDefault()
          close()
        }
      } catch (e) {
        warn(e)
      }
    }

    // Desktop: la card in alto a destra parte sotto il bordo inferiore dell'header
    // sticky (che a z-index 999 contiene account e carrello): a 20px dall'alto li copriva.
    // Su mobile (foglio dal basso) nessun top inline.
    function place() {
      try {
        popup.style.removeProperty('top')
        if (!window.matchMedia || !window.matchMedia('(min-width: 769px)').matches) return
        // il gruppo header ha piu' sezioni (banner spedizione + header): serve quella sticky
        var sections = document.querySelectorAll('.shopify-section-group-header-group')
        var header = null
        for (var i = 0; i < sections.length; i++) {
          var pos = window.getComputedStyle(sections[i]).position
          if (pos === 'sticky' || pos === 'fixed') {
            header = sections[i]
            break
          }
        }
        if (!header && sections.length) header = sections[sections.length - 1]
        if (!header) return
        var rect = header.getBoundingClientRect()
        var bottom = Math.round(rect.bottom)
        if (rect.height > 0 && bottom > 0 && bottom < window.innerHeight / 2) {
          popup.style.top = bottom + 12 + 'px'
        }
      } catch (e) {
        warn(e)
      }
    }

    function open(trigger) {
      try {
        state.trigger = trigger || null
        state.paused = false
        place()
        popup.hidden = false
        popup.removeAttribute('aria-hidden')
        state.open = true

        if (reduceMotion) {
          popup.classList.add('is-open')
        } else {
          // Doppio rAF per far partire la transizione; timeout di sicurezza se la scheda non e' visibile
          var opened = false
          var markOpen = function () {
            if (opened) return
            opened = true
            popup.classList.add('is-open')
          }
          requestAnimationFrame(function () {
            requestAnimationFrame(markOpen)
          })
          setTimeout(markOpen, 120)
        }

        document.addEventListener('keydown', onKeydown)

        // Focus iniziale programmatico sul pulsante principale: NON deve mettere in pausa
        // la chiusura automatica (il listener focusin ignora questo focus; la pausa vale
        // solo per focus/mouse/touch dell'utente). Senza questo flag il timer non partiva mai.
        state.autoFocus = true
        try {
          if (primary) primary.focus({ preventScroll: true })
          else if (panel) panel.focus({ preventScroll: true })
        } catch (e) {
          warn(e)
        }
        state.autoFocus = false

        startTimer()
      } catch (e) {
        warn(e)
      }
    }

    function close() {
      try {
        if (!state.open) return
        state.open = false
        clearTimer()
        document.removeEventListener('keydown', onKeydown)
        popup.classList.remove('is-open')

        var restoreFocus = popup.contains(document.activeElement)
        var finish = function () {
          popup.hidden = true
          popup.setAttribute('aria-hidden', 'true')
          popup.style.removeProperty('top')
          try {
            if (restoreFocus && state.trigger && document.contains(state.trigger)) {
              state.trigger.focus({ preventScroll: true })
            }
          } catch (e) {
            warn(e)
          }
        }
        if (reduceMotion) finish()
        else setTimeout(finish, 300)
      } catch (e) {
        warn(e)
      }
    }

    closers.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault()
        close()
      })
    })

    // Pausa del timer mentre l'utente legge / interagisce
    if (panel) {
      panel.addEventListener('mouseenter', function () {
        state.paused = true
        clearTimer()
      })
      panel.addEventListener('mouseleave', function () {
        state.paused = false
        if (state.open) startTimer()
      })
      panel.addEventListener('focusin', function () {
        if (state.autoFocus) return
        state.paused = true
        clearTimer()
      })
      panel.addEventListener('focusout', function (event) {
        try {
          if (event.relatedTarget && panel.contains(event.relatedTarget)) return
          state.paused = false
          if (state.open) startTimer()
        } catch (e) {
          warn(e)
        }
      })
      panel.addEventListener(
        'touchstart',
        function () {
          state.paused = true
          clearTimer()
        },
        { passive: true }
      )
    }

    function render(line, data) {
      try {
        var name = line.product_title || line.title || ''
        var variantTitle = line.variant_title || ''
        if (/^default title$/i.test(variantTitle)) variantTitle = ''

        if (title) {
          title.textContent = name
          var url = localizedUrl(line.url || '')
          if (url) title.setAttribute('href', url)
        }
        if (variant) variant.textContent = variantTitle
        if (qty) qty.textContent = String(line.quantity || 1)

        var unit = typeof line.final_price === 'number' ? line.final_price : line.price
        var unitFormatted = moneyFormat ? money(unit, moneyFormat, shopCurrency) : ''
        if (!unitFormatted && data.linePrice) unitFormatted = sanitizeHtml(data.linePrice)
        if (!unitFormatted && typeof unit === 'number') unitFormatted = (unit / 100).toFixed(2)
        if (price) price.innerHTML = unitFormatted

        var totalHtml = data.total ? sanitizeHtml(data.total) : ''
        if (!totalHtml && typeof data.totalCents === 'number') totalHtml = money(data.totalCents, moneyFormat, shopCurrency)
        if (total) total.innerHTML = totalHtml

        if (count) {
          if (typeof data.count === 'number') {
            count.textContent =
              '(' + (data.count === 1 ? itemsOne : itemsOther.replace('%COUNT%', String(data.count))) + ')'
          } else {
            count.textContent = ''
          }
        }

        var src = imageUrl((line.featured_image && line.featured_image.url) || line.image || '')
        if (image && imageWrap) {
          if (src) {
            image.src = src
            image.alt = (line.featured_image && line.featured_image.alt) || name || ''
            image.hidden = false
            imageWrap.classList.remove('is-empty')
            if (itemWrap) itemWrap.classList.remove('has-no-image')
          } else {
            image.removeAttribute('src')
            image.hidden = true
            imageWrap.classList.add('is-empty')
            if (itemWrap) itemWrap.classList.add('has-no-image')
          }
        }

        if (liveRegion) {
          var titleText = ''
          try {
            titleText = popup.querySelector('.stelt-cart-popup__title').textContent.trim()
          } catch (e) {
            titleText = ''
          }
          liveRegion.textContent = ''
          setTimeout(function () {
            liveRegion.textContent = (titleText ? titleText + ': ' : '') + name
          }, 60)
        }
      } catch (e) {
        warn(e)
      }
    }

    function onAdded(event) {
      try {
        var detail = (event && event.detail) || {}
        var resp = detail.product
        if (!resp || typeof resp !== 'object') return

        // Quick-add delle card (overlay.quick-add.js) invia {items:[...]}: /cart/add.js
        // risponde {items:[line], sections:{...}} invece del singolo line item.
        var line = resp
        if (Array.isArray(resp.items) && resp.items.length) line = resp.items[0]
        if (!line || typeof line !== 'object') return

        var html = (resp.sections && resp.sections['cart-ajax']) || (line.sections && line.sections['cart-ajax'])
        var data = parseSections(html, line.key)
        var showPopup = !detail.preventCartOpen

        var finish = function () {
          try {
            updateHeaderCount(popup, data.count)
            if (!showPopup) return
            render(line, data)
            open(detail.addToCartBtn || null)
          } catch (e) {
            warn(e)
          }
        }

        if (data.total && typeof data.count === 'number') {
          finish()
          return
        }

        fetchCart()
          .then(function (cart) {
            try {
              if (typeof cart.item_count === 'number') data.count = cart.item_count
              if (typeof cart.total_price === 'number') data.totalCents = cart.total_price
            } catch (e) {
              warn(e)
            }
            finish()
          })
          .catch(function (e) {
            warn(e)
            finish()
          })
      } catch (e) {
        warn(e)
      }
    }

    document.addEventListener(EVENT_ADDED, onAdded)

    // Espone un'API minima per altri script del tema
    try {
      window.SteltCartPopup = { open: open, close: close, updateCount: function (n) { updateHeaderCount(popup, n) } }
    } catch (e) {
      warn(e)
    }
  }

  try {
    if (window.__steltCartPopupInit) return
    window.__steltCartPopupInit = true

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        try {
          init()
        } catch (e) {
          warn(e)
        }
      })
    } else {
      init()
    }
  } catch (e) {
    warn(e)
  }
})()
